export default __webpack_public_path__ + "static/Places_Placeholder_3.0@2x-2d4aa7af92053f24996b872f0ef24a71.jpg";